module.exports = __webpack_public_path__ + "media/images/flags/1x1/aut-9007b4a3ca721aa1fd4e1ea53dd166e6.svg";